<div class="popover-wrapper" [class]="theme" [class.show-close]="displayCloseButton" #contentEl>
  <div class="popover-content">
    <h3 *ngIf="heading">{{ heading }}</h3>
    <p *ngIf="body">{{ body }}</p>
    <ng-content></ng-content>
  </div>
  <studio-icon
    *ngIf="displayCloseButton"
    name="close"
    size="24"
    title="close"
    (click)="close()"
  ></studio-icon>
</div>
